import React from "react";

export default class DailyGanttTable extends React.Component {

    state = {

        cells: [
            {}, {}, {}, {}, {},
            {}, {}, {}, {}, {}, {},
            {}, {}, {}, {}, {}, {}, {}, {},
            {}, {}, {}, {}, {},{}, {},{}, {},
        ]

    }
    render() {


        return (
            <div style={{ height: "600px", border: "0.1px solid #EBEDF1", borderBottom: "none", borderTop: "none", display: "flex", flexDirection: "row" }}>
                {this.state.cells.map((cell, index) => {
                    return (

                        <div className="cell">

                            
                        </div>
                    )

                })}
            </div>

        )
    }
}